import MindfitCircleWhiteSvg from '@centria-ui/assets/images/mindfit/mindfit-icon-white.svg'
import MindfitTextWhiteSvg from '@centria-ui/assets/images/mindfit/mindfit-text-white.svg'
import MindfitCircleSvg from '@centria-ui/assets/images/mindfit/mindfit-icon.svg'
import MindfitWhiteSvg from '@centria-ui/assets/images/mindfit/mindfit-white.svg'
import MindfitIaSvg from '@centria-ui/assets/images/mindfit/mindfit-icon-ai.svg'
import MindfitLogoSvg from '@centria-ui/assets/images/mindfit/logo.svg'
import MindfitSvg from '@centria-ui/assets/images/mindfit/mindfit.svg'
import Mindfit404Svg from '@centria-ui/assets/images/mindfit/404.svg'
import Mindfit500Svg from '@centria-ui/assets/images/mindfit/500.svg'
import ThanksSvg from '@centria-ui/assets/images/mindfit/thanks.svg'

export const ThanksIcon = () => <ThanksSvg />
export const MindfitIcon = () => <MindfitSvg />
export const MindfitIaIcon = () => <MindfitIaSvg />
export const Mindfit404Icon = () => <Mindfit404Svg />
export const Mindfit500Icon = () => <Mindfit500Svg />
export const MindfitLogoIcon = () => <MindfitLogoSvg />
export const MindfitWhiteIcon = () => <MindfitWhiteSvg />
export const MindfitCircleIcon = () => <MindfitCircleSvg />
export const MindfitTextWhiteIcon = () => <MindfitTextWhiteSvg />
export const MindfitCircleWhiteIcon = () => <MindfitCircleWhiteSvg />
